export const BID_MODE = {
  CAMPAIGN_WIDE_BID: 'CampaignWideBid',
  BID_SCALING: 'BidScaling',
  TARGET_ROAS: 'TROAS',
  TARGET_CPA: 'TCPA',
};
export const SYMBOL_PERCENT = {
  INCREASE: 0,
  DECREASE: 1,
};

export const STRING_MAP = {
  cost: 'KPI_Campaign_Cost',
  clicks: 'KPI_Campaign_Click',
  impressions: 'KPI_Campaign_Imp',
  mlImpressions: 'KPI_Campaign_MlImp',
  conversion: 'KPI_Campaign_Conversion',
  conversionValue: 'KPI_Campaign_ConversionValue',
};

export const TARGET_VALUE_MAP = {
  CampaignWideBid: 'Bid',
  BidScaling: 'Bid',
  TROAS: 'TargetROAS',
  TCPA: 'TargetCPA',
};

export const DESC_MAP = {
  CampaignWideBid: 'Campaign_BidLandscape_Desc',
  BidScaling: 'Campaign_BidLandscape_Desc',
  TCPA: 'Campaign_BidLandscape_TCPA_Desc',
  TROAS: 'Campaign_BidLandscape_TROAS_Desc',
};

export const ADDBUDGET_DESC_MAP = {
  CampaignWideBid: 'Campaign_BidLandscape_AdditionalBudget_Desc',
  BidScaling: 'Campaign_BidLandscape_AdditionalBudget_Desc',
  TCPA: 'Campaign_BidLandscape_AdditionalBudget_Target_Desc',
  TROAS: 'Campaign_BidLandscape_AdditionalBudget_Target_Desc',
};

export const TARGET_TITLE_MAP = {
  CampaignWideBid: 'KPI_Campaign_Bid',
  BidScaling: 'KPI_Campaign_Bid',
  TCPA: 'KPI_Campaign_TargetCPA',
  TROAS: 'KPI_Campaign_TargetROAS',
};

export const INPUTPLACEHOLDER_MAP = {
  CampaignWideBid: 'Campaign_BidlandscapeInputPlaceholder',
  BidScaling: 'Campaign_BidlandscapeInputPlaceholder_Scaling',
  TCPA: 'Campaign_BidlandscapeInputPlaceholder_Target',
  TROAS: 'Campaign_BidlandscapeInputPlaceholder_Target',
};
